import { render, staticRenderFns } from "./ChangePWD.vue?vue&type=template&id=ba076fb8&scoped=true"
import script from "./ChangePWD.vue?vue&type=script&lang=js"
export * from "./ChangePWD.vue?vue&type=script&lang=js"
import style0 from "./ChangePWD.vue?vue&type=style&index=0&id=ba076fb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba076fb8",
  null
  
)

export default component.exports